// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__F1DQl","spin":"Loading_spin__59x9a","spinner":"Loading_spinner__N6ODR"};